import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: "100%",
    minWidth: 0,
    paddingBottom: 18,
  },
  pageHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "2px 0 4px",
  },
  pageHeaderIcon: {
    width: 24,
    height: 24,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0f172a",
    color: "#fff",
    boxShadow: "0 8px 16px rgba(15, 23, 42, 0.18)",
    flexShrink: 0,
  },
  pageHeaderText: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  pageTitle: {
    fontSize: 17,
    lineHeight: 1.2,
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: -0.3,
  },
  pageSubtitle: {
    color: "#64748b",
    fontSize: 12,
  },
  typeTabsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  typeTabCard: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#fff",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
    padding: "14px 18px",
    display: "flex",
    alignItems: "center",
    gap: 14,
    cursor: "pointer",
    transition: "all 0.2s ease",
    minHeight: 76,
    outline: "none",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      transform: "translateY(-1px)",
      borderColor: "#d1d5db",
      boxShadow: "0 14px 26px rgba(15, 23, 42, 0.06)",
    },
    "&:focus-visible": {
      borderColor: "#16a34a",
      boxShadow: "0 0 0 3px rgba(22, 163, 74, 0.12)",
    },
  },
  typeTabCardActive: {
    borderColor: "#cfead7 !important",
    background: "linear-gradient(135deg, #f4fbf6 0%, #f8fffb 100%)",
    boxShadow: "0 14px 28px rgba(22, 163, 74, 0.08)",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: 3,
      background: "#16a34a",
    },
  },
  typeTabIcon: {
    width: 38,
    height: 38,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  typeTabText: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  typeTabTitle: {
    fontSize: 15,
    fontWeight: 900,
    color: "#0f172a",
    lineHeight: 1.2,
  },
  typeTabSubtitle: {
    color: "#64748b",
    fontSize: 12,
    lineHeight: 1.35,
  },
  metricsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 12,
    [theme.breakpoints.down("lg")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  metricCard: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#fff",
    padding: 14,
    display: "flex",
    alignItems: "center",
    gap: 12,
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
  },
  metricIcon: {
    width: 42,
    height: 42,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  metricContent: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  metricLabel: {
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    color: "#64748b",
    fontWeight: 900,
  },
  metricValue: {
    fontSize: 24,
    lineHeight: 1.05,
    fontWeight: 900,
    color: "#0f172a",
  },
  metricHelper: {
    fontSize: 12,
    color: "#94a3b8",
  },
  toolbarCard: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    background: "#fff",
    padding: 12,
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
  },
  toolbarRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  searchField: {
    flex: 1,
    minWidth: 280,
    "& .MuiInputBase-root": {
      borderRadius: 12,
      background: "#fff",
      minHeight: 40,
    },
    "& .MuiInputBase-input": {
      fontSize: 13,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e5e7eb",
    },
    "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#cbd5e1",
    },
    "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#16a34a",
      borderWidth: 1,
    },
  },
  searchIcon: {
    marginRight: 8,
    color: "#94a3b8",
  },
  addButton: {
    borderRadius: 10,
    textTransform: "none",
    fontWeight: "900 !important",
    paddingInline: 16,
    paddingBlock: 8,
    background: "#16a34a !important",
    color: "#ffffff !important",
    border: "1px solid #16a34a !important",
    boxShadow: "0 8px 18px rgba(22, 163, 74, 0.18)",
    "&:hover": {
      background: "#15803d !important",
      borderColor: "#15803d !important",
    },
  },
  tableCard: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
  },
  tableWrapper: {
    width: "100%",
    minWidth: 0,
  },
  dataGridTable: {
    border: 0,
    width: "100%",
    "& .MuiDataGrid-columnHeaders": {
      background: "#edf9f0 !important",
      borderBottom: "1px solid #dcecdf !important",
      minHeight: "54px !important",
      maxHeight: "54px !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "900 !important",
      textTransform: "uppercase",
      fontSize: "12px !important",
      color: "#15803d !important",
      letterSpacing: 0.4,
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #eef2f7 !important",
      outline: "none !important",
      paddingTop: 10,
      paddingBottom: 10,
      alignItems: "center",
    },
    "& .MuiDataGrid-row:hover": {
      background: "#fbfdfc",
    },
    "& .MuiDataGrid-virtualScroller": {
      overflowX: "hidden",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "1px solid #eef2f7",
      minHeight: 56,
    },
    "& .MuiTablePagination-toolbar": {
      minHeight: 56,
    },
  },
  snoCell: {
    fontSize: 13,
    fontWeight: 700,
    color: "#475569",
  },
  documentCell: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
  },
  documentIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eef4ff",
    color: "#2563eb",
    flexShrink: 0,
  },
  documentName: {
    fontSize: 13,
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
  },
  aliasCell: {
    fontSize: 13,
    color: "#475569",
    fontWeight: 600,
  },
  typeChip: {
    height: 30,
    fontWeight: 800,
    borderRadius: 999,
    borderWidth: 1,
    borderStyle: "solid",
    "& .MuiChip-icon": {
      color: "inherit",
      fontSize: 16,
      marginLeft: 8,
    },
    "& .MuiChip-label": {
      fontSize: 12,
      paddingLeft: 1,
      paddingRight: 12,
    },
  },
  statusChip: {
    height: 30,
    fontWeight: 800,
    borderRadius: 999,
    borderWidth: 1,
    borderStyle: "solid",
    "& .MuiChip-icon": {
      color: "inherit",
      fontSize: 16,
      marginLeft: 8,
    },
    "& .MuiChip-label": {
      fontSize: 12,
      paddingInline: 12,
    },
  },
  rowActionButton: {
    textTransform: "none",
    fontWeight: "800 !important",
    fontSize: 12,
    borderRadius: 8,
    paddingInline: 10,
    whiteSpace: "nowrap",
    borderColor: "#cdeed7 !important",
    color: "#15803d !important",
    background: "#fff !important",
    "&:hover": {
      borderColor: "#16a34a !important",
      background: "#f4fbf6 !important",
    },
  },
  actionMenu: {
    "& .MuiPaper-root": {
      borderRadius: 14,
      border: "1px solid #e5e7eb",
      boxShadow: "0 18px 34px rgba(15, 23, 42, 0.12)",
    },
    "& .MuiMenuItem-root": {
      display: "flex",
      gap: 10,
      minWidth: 160,
      fontWeight: 700,
    },
  },
  dialogRoot: {
    "& .MuiPaper-root": {
      borderRadius: 18,
      overflow: "hidden",
    },
  },
  dialogHeader: {
    padding: "16px 18px 10px",
  },
  dialogTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  dialogTitle: {
    fontWeight: 900,
    color: "#0f172a",
  },
  dialogContent: {
    paddingTop: "8px !important",
    paddingBottom: "12px !important",
  },
  formGrid: {
    paddingTop: 4,
  },
  dialogActions: {
    padding: "12px 18px 16px",
    gap: 10,
    justifyContent: "flex-end",
  },
  cancelButton: {
    textTransform: "none",
    borderRadius: 10,
    fontWeight: 800,
    color: "#475569",
  },
  saveButton: {
    textTransform: "none",
    borderRadius: 10,
    fontWeight: "900 !important",
    paddingInline: 18,
    background: "#16a34a !important",
    color: "#ffffff !important",
    border: "1px solid #16a34a !important",
    "&:hover": {
      background: "#15803d !important",
      borderColor: "#15803d !important",
    },
  },
  dangerButton: {
    textTransform: "none",
    borderRadius: 10,
    fontWeight: "900 !important",
    paddingInline: 18,
    background: "#dc2626 !important",
    color: "#ffffff !important",
    border: "1px solid #dc2626 !important",
    "&:hover": {
      background: "#b91c1c !important",
      borderColor: "#b91c1c !important",
    },
  },
  gridFooter: {
    borderTop: "1px solid #eef2f7",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "12px 16px 14px",
    flexWrap: "wrap",
  },
  gridFooterLeft: {
    color: "#64748b",
    fontSize: 13,
    fontWeight: 600,
  },
  gridFooterRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 16,
    flexWrap: "wrap",
    marginLeft: "auto",
  },
  rowsPerPageWrap: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  rowsPerPageLabel: {
    color: "#475569",
    fontSize: 13,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  rowsPerPageSelect: {
    width: 72,
    "& .MuiOutlinedInput-root": {
      height: 32,
      borderRadius: 8,
      background: "#fff",
    },
    "& .MuiSelect-select": {
      paddingTop: "5px !important",
      paddingBottom: "5px !important",
      fontSize: 13,
      fontWeight: 700,
      color: "#0f172a",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e2e8f0",
    },
    "& .MuiSvgIcon-root": {
      fontSize: 18,
      color: "#64748b",
    },
  },
  paginationWrap: {
    "& .MuiPagination-ul": {
      gap: 6,
    },
  },
  paginationItem: {
    minWidth: 34,
    height: 34,
    borderRadius: 8,
    fontSize: 13,
    fontWeight: "800 !important",
    color: "#475569",
    border: "1px solid transparent",
    margin: 0,
    "&.MuiPaginationItem-page": {
      borderColor: "#e2e8f0",
      background: "#fff",
    },
    "&.Mui-selected": {
      background: "#16a34a !important",
      color: "#ffffff !important",
      borderColor: "#16a34a !important",
      boxShadow: "0 8px 16px rgba(22, 163, 74, 0.18)",
    },
    "&.MuiPaginationItem-previousNext": {
      borderColor: "transparent",
      background: "transparent",
      color: "#9ca3af",
    },
    "&.Mui-disabled": {
      opacity: 0.4,
    },
  },
  deleteDialogContent: {
    paddingTop: "8px !important",
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  deleteDialogText: {
    color: "#475569",
  },
  deleteSummaryCard: {
    borderRadius: 14,
    border: "1px solid #fee2e2",
    background: "#fff7f7",
    padding: 14,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  deleteSummaryTitle: {
    fontWeight: 800,
    color: "#b42318",
  },
  deleteSummarySubtitle: {
    color: "#7f1d1d",
  },
}));

export default useStyles;
